import React = require("react")
import {Divider} from 'antd'

export default function() {
    return <Divider type="vertical" />
}


// WEBPACK FOOTER //
// ./src/toolbar/divider.tsx